import { useEffect, useRef } from "react";
import { MODES } from "./constants";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { DEFAULT_TOOLBAR } from "./constants";

const AlignStyle = Quill.import("attributors/style/align");
Quill.register(AlignStyle, true);

const SizeStyle = Quill.import("attributors/style/size");
delete SizeStyle.whitelist; // accept all
Quill.register(SizeStyle, true);

const Link = Quill.import("formats/link");
class MyLink extends Link {
  static create(value) {
    let node = super.create(value);
    value = this.sanitize(value);
    if (!value.startsWith("https")) {
      value = "https://" + value;
    }
    node.setAttribute("href", value);
    return node;
  }
}

Quill.register(MyLink);

export const Preview = ({ mode, editorState, onEditorStateChange, toolbar }) => {
  const quill = useRef();

  const imageHandler = () => {
    const tooltip = quill.current.theme.tooltip;
    const originalSave = tooltip.save;
    const originalHide = tooltip.hide;

    tooltip.save = () => {
      const range = quill.current.getSelection(true);
      const value = tooltip.textbox.value;

      if (value) {
        quill.current.insertEmbed(range.index, "image", value, Quill.sources.USER);
      }
    };

    tooltip.hide = () => {
      tooltip.save = originalSave;
      tooltip.hide = originalHide;
      tooltip.hide();
    };
    tooltip.edit("image");
    tooltip.textbox.placeholder = "Embed URL";
  };

  useEffect(() => {
    if (!quill.current) {
      quill.current = new Quill("#editor", {
        modules: {
          toolbar: {
            container: toolbar,
            handlers: {
              image: imageHandler,
            },
          },
        },
        theme: "snow",
      });

      quill.current.on("editor-change", (eventName) => {
        if (eventName === "text-change") {
          onEditorStateChange(quill.current.root.innerHTML);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (quill.current) {
      quill.current.root.innerHTML = "";
      quill.current.clipboard.dangerouslyPasteHTML(0, editorState);
    }
  }, [mode, editorState]);

  return (
    <div
      style={{
        zIndex: mode === MODES.EDIT ? -1000000 : 0,
        position: mode === MODES.EDIT ? "absolute" : "relative",
        visibility: mode === MODES.EDIT ? "hidden" : "visible",
      }}
    >
      <div id="editor" />
    </div>
  );
};

Preview.defaultProps = {
  toolbar: DEFAULT_TOOLBAR,
};
